"use client";

import styled from "styled-components";
import { LogoFullCu } from "@/components/ui/logo-cu/logo-full-cu";

/**
 * Styled Components
 */

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
`;

const HeaderContainer = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.Colors.white};
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.Colors.gray200};
`;

/**
 * Login Layout
 */

export default function LoginLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PageContainer>
      <HeaderContainer>
        <LogoFullCu size={170} />
      </HeaderContainer>
      {children}
    </PageContainer>
  );
}
